@let _discountedPrice = discountedPrice();
@let _isDiscountWithRecommendedPrice = isDiscountWithRecommendedPrice();
@let _recommendedPrice = recommendedPrice();
@let _price = price();
@let _isSmall = isSmall();

<p [ngClass]="{
    'c__discounted-price': _discountedPrice,
    'c__price-wrapper': !_discountedPrice,
    'is-discounted': _discountedPrice && !_isDiscountWithRecommendedPrice
    }"
>
  @if (_discountedPrice) {
    <span class="is-visually-hidden">
      {{ 'product.price.reducedPrice' | translate}}
    </span>
    <span [ngClass]="{'brand--h4': _isSmall, 'brand--h2': !_isSmall}">
      {{ _discountedPrice }}
      <sd-converted-price
        class="is-double-currency"
        textBeforePrice="/ "
        [price]="_discountedPrice"
      />
    </span>
  }
  <span class="is-visually-hidden">
    {{ (_discountedPrice ? 'product.price.initialPrice' : 'product.price.price') | translate}}
  </span>

  @if (!(_discountedPrice && _isDiscountWithRecommendedPrice)) {
    <span class="c__price" [ngClass]="{
      'is-body-s': _discountedPrice && _isSmall,
      'brand--h5': _discountedPrice && !_isSmall,
      'is-text-dark': !_discountedPrice,
      'brand--h4': _isSmall && !_discountedPrice,
      'brand--h2': !_isSmall && !_discountedPrice
      }"
    >
      <span [ngClass]="{'is-price-through': _discountedPrice}">
        {{ _price }}
        <sd-converted-price
          class="is-double-currency"
          textBeforePrice="/ "
          [displayComponent]="!(_discountedPrice && !_isDiscountWithRecommendedPrice)"
          [price]="_price"
        />
      </span>
      @if (_discountedPrice && !isBundle() && !_isDiscountWithRecommendedPrice) {
        <span>*</span>
      }
    </span>
  }

  @if ((_recommendedPrice && !_discountedPrice && !_isDiscountWithRecommendedPrice) || (_discountedPrice && _isDiscountWithRecommendedPrice)) {
    <ng-container *ngTemplateOutlet="recommendedPriceTpl; context: {position: PositionEnum.topRight}" />
  }
</p>

@if (_discountedPrice && !isBundle() && !_isDiscountWithRecommendedPrice) {
  <p class="is-caption is-bold">
    *&nbsp;{{('product.strikethroughPrice.message' | translate) }}
  </p>
}

@if (_recommendedPrice && _discountedPrice && !_isDiscountWithRecommendedPrice) {
  <ng-container *ngTemplateOutlet="recommendedPriceTpl; context: {position: PositionEnum.bottom}" />
}

<ng-template #recommendedPriceTpl let-position="position">
  <p
    [ngClass]="{
      'is-position-bottom': position === PositionEnum.bottom,
      'is-position-top': position === PositionEnum.topRight
    }"
    class="c__recommended-price-wrapper"
  >
    <span class="c__recommended-price-text" [ngClass]="{'is-overline': _isSmall, 'is-caption': !_isSmall}">
      {{ 'product.price.recommendedPrice' | translate }}
      @if (!_discountedPrice) {
        <span>*</span>
      }
  </span>
  <button type="button" role="button" class="is-reset is-full-area c__recommended-price-button" (click)="onOpenRecommendedPriceModal()">
    <sd-icon name="icon-help" />
  </button>
    <span
      class="c__recommended-price is-bold"
      [ngClass]="{
        ' is-caption': _isSmall,
        'brand--h5': !_isSmall && position === PositionEnum.topRight
      }"
    >
      {{ !_isDiscountWithRecommendedPrice ? _recommendedPrice : _price }}
    </span>
  </p>
</ng-template>
